<template>
  <div class="detail-row">
    <!-- <font-awesome-icon :icon="icon" /> -->
    <div class="detailtitle">
      <b>{{ title }}</b>

      {{ value }}
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  props: ["icon", "title", "value", "showButton", "buttonText", "hasImage"],
};
</script>
<style scoped>
svg {
  top: 4px;
  position: relative;
}

.detailtitle {
  margin: 0 10px;
  text-align: right;
  color: white;
}

.detail-row {
  display: flex;
  
}
</style>
